import CardQueueDataGrid from "../CardQueueDataGrid";
export default class CardQueueDataGridInboundCommunication extends CardQueueDataGrid {
  columns = {
    "inbound_communication.id": {
      type: "number",
      name: "ID",
      width: 110,
    },
    "inbound_communication.patient_id": {
      type: "number",
      name: "Patient ID",
      width: 120,
    },
    "inbound_communication.inbound_communication_channel_term_id": {
      type: "term",
      name: "Channel",
      width: 120,
    },
    "inbound_communication.inbound_communication_type_term_id": {
      type: "term",
      name: "Type",
      width: 120,
    },
    "inbound_communication.json_data": {
      type: "term",
      name: "Data",
      width: 120,
    },
    "inbound_communication.patient._name": {
      type: "string",
      name: "Patient Name",
      width: 140,
    },
    "inbound_communication.order_activity_id": {
      type: "number",
      name: "Order #",
      width: 120,
    },
    "inbound_communication.json_data._body": {
      source: "inbound_communication.json_data",
      type: "inboundCommunicationBody",
      name: "Message",
      width: 300,
    },
    "inbound_communication.json_data._from": {
      source: "inbound_communication.json_data",
      type: "inboundCommunicationFromPhoneNumber",
      name: "From #",
      width: 140,
    },
    "inbound_communication.json_data._media_urls": {
      source: "inbound_communication.json_data",
      type: "inboundCommunicationMediaUrls",
      name: "Media Urls",
      excludeFromCsv: true,
      width: 150,
    },
    "inbound_communication.created_at": {
      type: "dateTime",
      name: "Received At",
      width: 160,
    },
    out_of_bounds: {
      type: "boolean",
      name: "OOB",
      width: 80,
    },
  };

  /**
   * Handle clicking on a grid row.
   */
  handleClickRow(row) {
    if (this.props.onClickRow) {
      this.props.onClickRow();
    }

    this.openOrder(row);
  }

  /**
   * Opens the order.
   *
   * @param {Object} row The grid row.
   */
  openOrder(row) {
    if (row["inbound_communication.order_activity_id"]) {
      window.open(
        `/chart/${row["inbound_communication.patient_id"]}/order/${row["inbound_communication.order_activity_id"]}`,
        "_blank",
      );
    } else if (row["inbound_communication.patient_id"]) {
      window.open(
        `/chart/${row["inbound_communication.patient_id"]}`,
        "_blank",
      );
    }
  }
}
